import React from "react";
import Router from "./App/Routes/Router";

function App() {
  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
